'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _bind = require('classnames/bind');

var _bind2 = _interopRequireDefault(_bind);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var styles = require('./TabsWrapper.scss');

var TabsWrapper = (_temp = _class = function (_PureComponent) {
  (0, _inherits3.default)(TabsWrapper, _PureComponent);

  function TabsWrapper() {
    (0, _classCallCheck3.default)(this, TabsWrapper);
    return (0, _possibleConstructorReturn3.default)(this, (TabsWrapper.__proto__ || (0, _getPrototypeOf2.default)(TabsWrapper)).apply(this, arguments));
  }

  (0, _createClass3.default)(TabsWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children,
          pullRight = _props.pullRight;


      return _react2.default.createElement(
        'ul',
        { className: (0, _bind2.default)(styles.tabs, className, { 'pull-right': pullRight }) },
        children
      );
    }
  }]);
  return TabsWrapper;
}(_react.PureComponent), _class.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.node, _propTypes2.default.arrayOf(_propTypes2.default.node)]),
  className: _propTypes2.default.string,
  pullRight: _propTypes2.default.bool
}, _class.defaultProps = {
  pullRight: false
}, _temp);
exports.default = TabsWrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Tabs/TabsWrapper/TabsWrapper.js
// module id = 854
// module chunks = 1